/* Kevin 4.11.2026: Kontakt- und Newsletterformulare -> Bexio-Kontakt.
   Bei jeder Absendung eines Shopify-Kontakt- oder Newsletterformulars gehen E-Mail, Name, Telefon,
   "Ich bin" und Nachricht an den Make-Webhook (Szenario 8368289 "azado.ch Formulare -> Bexio Kontakt").
   Make legt den Kontakt nur an, wenn die E-Mail in Bexio noch fehlt. Newsletter-Formulare bekommen
   zusaetzlich den Kunden-Tag "ich-bin-...". sendBeacon ueberlebt das Neuladen nach dem Absenden. */
(function () {
  var HOOK = 'https://hook.eu1.make.com/s7w5q01hhxhaodtdxw9hm1s8sge2mq7r';
  var NAMES = {
    ContactForm: 'Kontaktseite', AzConcierge: 'Kontakt-Popup', 'az-ak-contact': 'Aussenküche Anfrage',
    AzCfgQuoteForm: 'Grill-Konfigurator', 'az-member-form-band': 'Newsletter Footer',
    'az-member-form-popup': 'Newsletter Popup', AzNewsInline: 'Newsletter Startseite'
  };
  var sent = {};
  /* Anfuehrungszeichen, Backslash und Steuerzeichen raus, sonst bricht das JSON fuer Bexio */
  function clean(v, max) { return String(v || '').replace(/[\u0000-\u001f"\\<>]/g, ' ').replace(/\s+/g, ' ').trim().slice(0, max || 120); }
  function val(f, sel) { var e = f.querySelector(sel); return e ? e.value : ''; }
  function slug(s) { return s.toLowerCase().replace(/[äÄ]/g, 'ae').replace(/[öÖ]/g, 'oe').replace(/[üÜ]/g, 'ue').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.tagName !== 'FORM') return;
    var type = val(f, 'input[name="form_type"]');
    if (type !== 'contact' && type !== 'customer') return;
    var email = clean(val(f, 'input[name="contact[email]"]'), 120).toLowerCase();
    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) return;

    var sel = f.querySelector('select[data-az-ichbin]');
    var ich = sel ? sel.value : '';
    var opt = sel && sel.selectedOptions ? sel.selectedOptions[0] : null;
    if (type === 'customer' && ich) {
      var tags = f.querySelector('input[name="contact[tags]"]');
      if (tags && tags.value.indexOf('ich-bin-') < 0) tags.value += ', ich-bin-' + slug(ich);
    }

    /* Doppelte Absendung (Spamschutz laedt neu, Doppelklick) nur einmal melden */
    if (sent[email] && Date.now() - sent[email] < 15000) return;
    sent[email] = Date.now();

    var name = clean(val(f, 'input[autocomplete="name"], input[name="contact[name]"]'), 80);
    var parts = name.split(' ');
    var vorname = parts.length > 1 ? parts.shift() : '';
    var nachname = parts.join(' ');
    var anliegen = val(f, 'input[name="contact[Anliegen]"]');
    var data = new URLSearchParams({
      art: type === 'customer' ? 'newsletter' : 'kontakt',
      quelle: clean((NAMES[f.id] || f.id || 'Formular') + (anliegen ? ', ' + anliegen : ''), 80),
      email: email,
      vorname: vorname,
      nachname: nachname,
      telefon: clean(val(f, 'input[type="tel"]'), 40),
      ichbin: clean(ich, 60),
      branche: opt ? (opt.getAttribute('data-b') || '') : '',
      nachricht: type === 'contact' ? clean(val(f, 'textarea'), 400) : '',
      seite: clean(location.pathname, 120)
    });
    try {
      if (!(navigator.sendBeacon && navigator.sendBeacon(HOOK, data))) {
        fetch(HOOK, { method: 'POST', body: data, mode: 'no-cors', keepalive: true });
      }
    } catch (err) {}
  }, true);
})();
